import echartsTheme from '../theme/echarts';

// map chart
// left = 20
// bottom = 60


// line chart
// left = 76
// bottom = 72


export const renderChartCopyright = ({ isMobileView }, left = 20, bottom = 60) => {
    const leftPosition = isMobileView ? 5 : left;
    return {
        elements: [
            {
                type: 'text',
                style: {
                    ...echartsTheme.textStyle,
                    fontSize: 12,
                    text: 'Powered by IHME Client Services',
                },
                z: 10,
                left: leftPosition,
                bottom: bottom + (isMobileView ? 30 : 20),
            },
            {
                type: 'text',
                style: {
                    ...echartsTheme.textStyle,
                    fontSize: 12,
                    text: `Source: Institute for Health Metrics and Evaluation (IHME).${isMobileView ? '\n' : ' '}Used with permission. All rights reserved.`,
                },
                z: 10,
                left: leftPosition,
                bottom,
            },
        ],
    };
};
